import { useCallback, useState, useMemo } from "react";

export interface UseUseAnchorElementProps<T> {
  anchorEl?: T | null;
}

function useAnchorElement<T extends unknown>(props?: UseUseAnchorElementProps<T>) {
  const { anchorEl = null } = props || {};

  const [anchorElement, setAnchorElement] = useState<T | null>(anchorEl);

  // Track if an initial anchorEl was provided
  const hasInitialAnchor = useMemo(() => anchorEl !== null, [anchorEl]);

  const onSetAnchorElement = useCallback((e: React.MouseEvent<T>) => setAnchorElement(e.currentTarget), []);

  const onRemoveAnchorElement = useCallback(() => setAnchorElement(null), []);

  return useMemo(
    () => ({
      anchorElement,
      setAnchorElement,
      onSetAnchorElement,
      onRemoveAnchorElement,
      hasInitialAnchor,
    }),
    [anchorElement, onRemoveAnchorElement, onSetAnchorElement, hasInitialAnchor]
  );
}

export default useAnchorElement;
